export function martinaRoomPath(roomId: number, returnTo?: string): string {
  if (!returnTo) return `/?room=${roomId}&drawer=1`;
  return `/?room=${roomId}&drawer=1&returnTo=${encodeURIComponent(returnTo)}`;
}

export function martinaRoomIdFromSearch(search: string): number | null {
  const id = Number(new URLSearchParams(search).get("room"));
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function martinaRoomSourceFromSearch(search: string): 'home' | 'notification' {
  return new URLSearchParams(search).get('source') === 'notification'
    ? 'notification'
    : 'home';
}
